import api from '../../../services/api';

const URL = '/todo_categories';

/*
| No trailing slashes.
|
| `/todo_categories/{id}/` does not match `Route::put('todo_categories/{id}')`. Laravel
| only redirects a trailing slash for GET/HEAD; for other verbs the server in front of it
| returns a 301, and a 301 on a preflighted PUT or DELETE reaches the browser without CORS
| headers — so a routing mistake is reported as a CORS failure. This is the same bug that
| broke saving members and labels from the task drawer.
*/

const todoCategoryService = {
  getCategories() {
    return api.get(URL);
  },

  getCategory(id) {
    return api.get(`${URL}/${id}`);
  },

  createCategory(data) {
    return api.post(URL, data);
  },

  updateCategory(id, data) {
    return api.put(`${URL}/${id}`, data);
  },

  deleteCategory(id) {
    return api.delete(`${URL}/${id}`);
  },
};

export default todoCategoryService;
